/* ============================================================
   KN — cart change hardening

   Shopify's /cart/change.js does NOT clamp quantity to available
   stock. It returns HTTP 422 with a description like
   "Only 2 items were added to your cart due to availability."
   and no items array.

   The base handler paints from the response, so a 422 would throw
   and fall through to a silent re-fetch: the number snaps back with
   no explanation. This wraps KNCart.change so the shopper is told
   what happened, and the drawer is always repainted from the real
   cart afterwards.

   This file is loaded deferred from <head>, so it executes BEFORE
   kn-design-app.js and window.KNCart does not exist yet. All wiring
   therefore happens on DOMContentLoaded, which fires after every
   deferred script has run.
   ============================================================ */
(function () {
  "use strict";

  var busy = false;

  function body() { return document.getElementById("cartBody"); }

  function note(msg) {
    var b = body();
    if (!b) return;
    var old = b.querySelector(".cart-note");
    if (old && old.parentNode) old.parentNode.removeChild(old);
    var p = document.createElement("p");
    p.className = "cart-note";
    p.setAttribute("role", "status");
    p.textContent = msg;
    b.insertBefore(p, b.firstChild);
    setTimeout(function () { if (p.parentNode) p.parentNode.removeChild(p); }, 4500);
  }

  function change(line, quantity, vid) {
    if (busy) return Promise.resolve();
    if (!(quantity >= 0)) quantity = 0;
    busy = true;
    var b = body();
    if (b) b.classList.add("is-busy");

    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) {
        return r.json()
          .catch(function () { return null; })
          .then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        var refresh = (window.KNCart && window.KNCart.refresh)
          ? window.KNCart.refresh
          : function () { return Promise.resolve(); };

        if (res.ok && res.data && res.data.items) return refresh();

        /* Refused, almost always stock. Repaint the truth first, because
           repainting replaces the cart body and would wipe the message. */
        var msg = (res.data && (res.data.description || res.data.message)) ||
                  "That quantity is not available right now.";
        return refresh().then(function () { note(msg); });
      })
      .catch(function () {
        if (window.KNCart && window.KNCart.refresh) return window.KNCart.refresh();
      })
      .then(function (out) {
        busy = false;
        var bb = body();
        if (bb) bb.classList.remove("is-busy");
        return out;
      });
  }

  function boot() {
    if (window.KNCart) window.KNCart.change = change;

    /* Capture phase, so this runs before the drawer's own delegated
       listener; stopPropagation keeps that one from firing a duplicate
       request for the same click. */
    document.addEventListener("click", function (e) {
      var b = body();
      if (!b || !b.contains(e.target)) return;

      var step = e.target.closest(".qtybox__b");
      if (step) {
        if (step.disabled) return;
        e.stopPropagation();
        change(+step.getAttribute("data-line"), +step.getAttribute("data-to"), +step.getAttribute("data-vid"));
        return;
      }

      var rm = e.target.closest("[data-rm]");
      if (rm) {
        e.stopPropagation();
        change(+rm.getAttribute("data-rm"), 0);
      }
    }, true);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
